module.exports = __webpack_public_path__ + "static/videos/litho_003.cda77f8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/litho/litho_003.mp4
// module id = 472
// module chunks = 1